import { renderClasses } from '@agilepoint/utils-common';
import { IMessageProps } from './message-props';
import { excludeKeys } from '../../utils';

export function MessageBase(props: IMessageProps) {
    const { message, elementRef, hidden, className = '' } = props;
    const textProps = excludeKeys(props, 'className', 'children', 'message', 'elementRef');
    return hidden ? null : (
        <span {...textProps} className={renderClasses(['ap-message', className])} ref={elementRef}>{message}</span>
    );
}
